import React from "react"
import styled, { css } from "styled-components"
import { useIntl, FormattedMessage } from "gatsby-plugin-react-intl"

import Link from "../components/Link"

import { media, mixins } from "../styles"
// import ExternalSVG from "../images/icons/external.inline.svg"

const LinkList = styled.ul`
  ${mixins.headerSpacing}
  display: none;
  list-style: none;
  margin: 0;
  padding: 0;

  @media ${media.md} {
    display: flex;
  }
`

const ListItem = styled.li`
  align-items: center;
  display: flex;
  justify-content: center;

  &.hide-md {
    @media ${media.md} {
      display: none;
    }

    @media ${media.lg} {
      display: flex;
    }
  }

  &.hide-lg {
    @media ${media.lg} {
      display: none;
    }

    @media ${media.xl} {
      display: flex;
    }
  }
`

const LinkItem = styled(Link)`
  color: ${({ theme }) => theme.spaceblue};
  font-weight: 700;
  text-decoration: none;

  > span {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  ${(props) =>
    props.$button &&
    css`
      background: ${({ theme }) => theme.blueberry};
      border-radius: 1em;
      /* margin: 0 0 0 35px; */
      padding: 6px 15px;
      transition:
        background ${({ theme }) => theme.transitionTime},
        color ${({ theme }) => theme.transitionTime};

      &:hover {
        background: ${({ theme }) => theme.sun};
        color: ${({ theme }) => theme.white};
      }
    `}

  svg {
    margin: 0 0 0 5px;
  }
`

const HeaderShortlinks = ({ className }) => {
  // using intl so that links also work for the blog
  const intl = useIntl()
  return (
    <LinkList className={className}>
      <ListItem>
        <LinkItem to={`/${intl.locale}/survey/`} intl={false}>
          <FormattedMessage id="header.shortlinks.cta" />
        </LinkItem>
      </ListItem>
    </LinkList>
  )
}

export default HeaderShortlinks
